<mat-card>
    <mat-card-header style="margin-bottom: 20px">
        <mat-card-title>Indicação</mat-card-title>
        <button
            mat-mini-fab
            style=" margin-left: 10px"
            matTooltip="ADICIONAR INDICAÇÃO"
            (click)="openCadastro()">
            <mat-icon>add_circle</mat-icon>
        </button>
    </mat-card-header>
    <mat-card-content>
        <ngx-datatable 
            #table 
            class='material striped' 
            [loadingIndicator]="loadingIndicator"
            [columns]="columns" 
            [columnMode]="'force'" 
            [headerHeight]="50"
            [footerHeight]="50" 
            [rowHeight]="'auto'"
            [rows]='rows'
        >
            <ngx-datatable-column 
                name="Nome" 
                matTooltip='Nome' 
                prop="nome">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.nome}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column 
                name="Telefone" 
                matTooltip='Telefone' 
                prop="telefone">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.telefone}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
                name="Observação" 
                matTooltip='Observação' 
                prop="observacao">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ row.observacao }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <button mat-icon-button matTooltip="Altera Item" (click)="openAlterar(row.id)">
                        <mat-icon aria-label="Editar">edit</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" matTooltip="Excluir Item." (click)="delete(row.id)">
                        <mat-icon aria-label="Excluir Item">delete</mat-icon>
                    </button>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
        <div style="padding: 5px 10px">
            <mat-paginator 
                #paginator 
                [length]="length"
                [pageSize]="pageSize"
                [pageSizeOptions]="pageSizeOptions"
                (page)="pageEvent($event)">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>